/**
 * @fileoverview Zod schema for the Sales Pipeline "Assign Target" form (POST /sales/targets).
 * @description The batch's shared fields: a name (1 to 150 characters), the assignee, the period
 * type and one of that type's open periods, and the priority. The prospects come from the table's
 * selection and the due date from the period, so neither is a field. Every message is a
 * translation key, translated only at the display call site in AssignProspectTargetModal.
 * @copyright Copyright (c) 2026 Brownbox Consulting. All rights reserved.
 * @author Anshul Rokde
 */

import { z } from 'zod'

/** @description The Assign Target form's rules. */
export const assignProspectTargetFormSchema = z.object({
  name: z
    .string()
    .trim()
    .min(1, 'sales.pipeline.assign.errors.nameRequired')
    .max(150, 'sales.pipeline.assign.errors.nameTooLong'),
  assigneeUserId: z.string().trim().min(1, 'sales.pipeline.assign.errors.assigneeRequired'),
  periodType: z.enum(['MONTHLY', 'QUARTERLY', 'BI_ANNUAL', 'ANNUAL']),
  periodLabel: z.string().trim().min(1, 'sales.pipeline.assign.errors.periodRequired'),
  priority: z.enum(['HIGH', 'MEDIUM', 'LOW']),
})

/** @description The Assign Target form's values. */
export type AssignProspectTargetFormValues = z.infer<typeof assignProspectTargetFormSchema>
